import { ApiError, ApiParameter, get, rawRequest, request } from "@insite/client-framework/Services/ApiService";

export interface GetSizesResultModel{
    result:any
}

export interface GetSizesParameter extends ApiParameter{
    ProductName?:string
}

export const GetSizesUrl = "api/v2/hangtagsize"

export async function GetSizes(params:GetSizesParameter) {
    const response = await fetch(`${GetSizesUrl}`,{
        method:"POST",
        headers:{
            "Content-Type": "application/json",
        },
        body:JSON.stringify(params)
    });
    
    try{
        const result = response.ok && (await response.json())
        if (!response.ok) {
            throw new Error(
                JSON.stringify({
                    status: response.status,
                    errorJson: {
                        message: response.statusText,
                    },
                }),
            );
        }
        return result;

    } catch(error){
        let message: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string; exceptionMessage?: string };
            message = errorJson.exceptionMessage ?? errorJson.message;
        } else {
            message = await response.text();
        }
        throw new ApiError(GetSizesUrl, response, message, errorJson);
    }
}